import React, { useContext, useEffect, useState } from "react";
import { Title } from "../Header";
import EmojiEventsOutlinedIcon from "@material-ui/icons/EmojiEventsOutlined";
import { TableauMarkSelectionView } from "../TableauView";
import { AnalyticsSkeleton } from "../Analytics/AnalyticsSkeleton";
import { AnalyticsError } from "../Analytics/AnalyticsError";
import { UserContext } from "../UserContext";
import { ViewSelector } from "../Analytics/ViewSelector";
import { TeamSelector } from "../Analytics/TeamSelector";
import { useViewDetails } from "../useViewDetails";
import { MetricsIcon } from "../Header/Icons";
import { makeStyles } from "@material-ui/core";

const dimensions = {
  placeholderWidth: "100%",
  placeholderHeight: "500px",
  vizWidth: "100%",
  vizHeight: "100vh",
};

const agencyMetricsDimensions = {
  placeholderWidth: "100%",
  placeholderHeight: "100px",
  vizWidth: "100%",
  vizHeight: "100px",
};

const useStyles = makeStyles((theme) => ({
  screenContainer: {
    paddingBottom: theme.spacing(6),
  },
  container: {
    paddingLeft: 30,
    paddingRight: 30,
  },
}));

const SPCDashboard = () => {
  const classes = useStyles();

  const title = "SPC";
  const icon = EmojiEventsOutlinedIcon;

  const agencyAnalyticsApi = "/api/metrics/v1/analytics/spc";
  const agencyAnalyticsDetails = useViewDetails(agencyAnalyticsApi);
  const { fetching, success, error, data } = agencyAnalyticsDetails;

  return (
    <div className={classes.container}>
      <Title icon={icon} titleText={title} />
      {fetching && <AnalyticsSkeleton />}
      {success && (
        <TableauMarkSelectionView
          {...data}
          {...agencyMetricsDimensions}
          adjustHeight={true}
        />
      )}
      {error && <AnalyticsError />}
    </div>
  );
};

export default SPCDashboard;
